import __request__ from "routing/request";
export function splitAndIndexTester(split_by, index, string, requestOptions) {
  return __request__("GET", "/tools/split_and_index_tester", null, { "split_by": split_by, "index": index, "string": string }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function splitAndIndexTest(JSONbody, requestOptions) {
  return __request__("POST", "/tools/split_and_index_tester", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
